import React from 'react';
import { useDispatch } from 'react-redux';
import { setFiltroUsuarios } from "../../actions/usuariosActions";

export default function FiltroUsuarios({ filtro, fetchUsuarios, handleReset }) {
  const dispatch = useDispatch();
  const { nombreUsuario } = filtro;

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedParams = { ...filtro, [name]: value };

    dispatch(setFiltroUsuarios(updatedParams));
  };

  return (
    <div className="card card-body filter-card admin-filter-panel mb-3">
      <form
        className="form-material"
        onSubmit={(e) => {
          e.preventDefault();
          dispatch(setFiltroUsuarios({ ...filtro, numeroPagina: 1 })).then(() => fetchUsuarios());
        }}
      >
        <div className="row align-items-end g-2 g-md-3">
          <div className="col-12 col-sm-4 col-md-3">
            <label className="label-oscura">Nombre de usuario</label>
            <input
              type="text"
              name="nombreUsuario"
              className="form-control"
              value={nombreUsuario || ""}
              onChange={handleChange}
              maxLength="30"
              onInput={(e) => e.target.setCustomValidity("")}
              autoComplete="off"
              placeholder="Mín. 3 caracteres al buscar"
            />
          </div>
          <div className="col-12 col-sm-4 col-md-3">
            <label className="label-oscura">Estado</label>
            <select
              name="activo"
              className="form-control"
              value={filtro.activo !== undefined ? filtro.activo : ""}
              onChange={(e) => {
                const val = e.target.value;
                const activoValue = val === "true" ? true : (val === "false" ? false : undefined);
                const updatedParams = { ...filtro, activo: activoValue };
                dispatch(setFiltroUsuarios(updatedParams));
              }}
            >
              <option value="">Todos</option>
              <option value="true">Activos</option>
              <option value="false">Inactivos</option>
            </select>
          </div>

          <div className="col-12 col-sm-auto ms-sm-auto d-flex flex-wrap justify-content-sm-end gap-2 pt-1 pt-sm-0">
            <button type="submit" className="btn btn-sm btn-grey">Buscar</button>
            <button type="button" className="btn btn-sm btn-grey" onClick={handleReset}>
              Limpiar
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}